var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNotiConfirm = function SvgIcNotiConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 20c0 9.941-8.059 18-18 18S2 29.941 2 20 10.059 2 20 2s18 8.059 18 18Zm2 0c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Zm-11.782-5.1a1 1 0 1 0-1.579-1.228l-8.223 10.58-4.605-4.139a1 1 0 1 0-1.337 1.488l5.403 4.857a1 1 0 0 0 1.459-.13l8.882-11.429Z"
  })));
};
export default SvgIcNotiConfirm;